module.exports = __webpack_public_path__ + "static/media/oblong_f.8f992839.svg";